import React from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { connect } from 'react-redux';
import eventTracker from '../../../../helpers/eventTracker';
import { Button } from '../../components';
import events from '../../events';
import { cdnBaseUrl } from '../../../../app/apis';

import {
  LeftArrow,
  RightArrow,
  HorizontalBullet,
  OpacityAnimation
} from '../../../../styles/common-styles';

const SMCarousel = ({
  spMaterialIndex,
  spotlight_materials,
  setSpMaterialIndex,
  spMaterialClickHandler,
  windowsWidth,
  templateColors
}) => {
  const {
    mat_nm,
    mat_cat_header,
    mat_cat_description,
    mat_img
  } = spotlight_materials[spMaterialIndex];
  const { main_color } = templateColors;

  const leftButtonClickHandler = () => {
    setSpMaterialIndex((prevState) => prevState - 1);
    eventTracker(
      events.HOME_SCREEN_MATERIAL_SPOTLIGHT_BACK_BTN_TAP,
      { material_id: spotlight_materials[spMaterialIndex - 1].mat_id }
    );
  };

  const rightButtonClickHandler = () => {
    setSpMaterialIndex((prevState) => prevState + 1);
    eventTracker(
      events.HOME_SCREEN_MATERIAL_SPOTLIGHT_NEXT_BTN_TAP,
      { material_id: spotlight_materials[spMaterialIndex + 1].mat_id }
    );
  };

  return (
    <>
      <MaterialItemContainer
        key={spMaterialIndex}
        onClick={spMaterialClickHandler}
        windowsWidth={windowsWidth}
      >
        <ImageContainer>
          <Image
            src={`${cdnBaseUrl}/gallery/${mat_img}`}
            alt="blog-galery"
            height="140px"
          />
        </ImageContainer>
        <ContextContainer>
          <ContextCategoryHeader>
            {mat_cat_header.replace(/<[^>]+>/g, '')}
          </ContextCategoryHeader>
          <ContextTitle>
            {mat_nm}
          </ContextTitle>
          <SMSummary>
            {mat_cat_description
              .replace(/<[^>]+>/g, '')
              .replaceAll('&amp;', '&')
              .replaceAll('&#160;', ' ')}
          </SMSummary>
          <Button
            mainColor={main_color || false}
            onClick={spMaterialClickHandler}
            margin="30px 0 0 auto"
            aria-label={`Find out, ${mat_nm}`}
          >
            {_('homePage.find_out')}
          </Button>
        </ContextContainer>
      </MaterialItemContainer>
      <Carousel>
        {spotlight_materials.map((bullet, bulletIndex) => (
          <HorizontalBullet
            onClick={() => setSpMaterialIndex(bulletIndex)}
            isCurrentSlide={spMaterialIndex === bulletIndex}
          />
        ))}
      </Carousel>
      <LeftArrow
        disabled={spMaterialIndex === 0}
        onClick={leftButtonClickHandler}
        aria-label="Previous"
      >
        &#8678;
      </LeftArrow>
      <RightArrow
        disabled={spMaterialIndex === spotlight_materials.length - 1}
        onClick={rightButtonClickHandler}
        aria-label="Next"
      >
        &#8680;
      </RightArrow>
    </>
  );
};

export default connect((store) => ({
  templateColors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
}), null)(SMCarousel);

const MaterialItemContainer = styled.div`
  display: flex;
  flex-direction: ${({ windowsWidth }) => windowsWidth < 650 && 'column'};
  padding: 0 27px;
  margin: 0 18px;
  margin-bottom: 15px;
  transition: all 0.3s;
  border-radius: 5px;
  z-index: 20000;
  animation: ${OpacityAnimation} 0.5s;
  cursor: pointer;
  
  &:hover {
    transition: all 0.3s;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
`;

const Image = styled.img`
  max-width: ${({ height }) => `${height}`};
  height: ${({ height }) => `${height}`};
  border-radius: 3px;
  object-fit: cover;
`;

const ContextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 10px !important;
  padding: 10px 0;
  overflow: hidden;
  animation: ${OpacityAnimation} 0.5s;
`;

const ContextCategoryHeader = styled.h3`
  margin: 0 !important;
  padding-bottom: 10px !important;
  font-size: 18px !important;
  color: #387AA8 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif !important;
`;

const ContextTitle = styled.h4`
  margin: 0 !important;
  font-size: 16px !important;
  color: #404040 !important;
  font-weight: 600 !important;
  letter-spacing: 1px;
  font-family: Roboto, sans-serif !important;
`;

const SMSummary = styled.div`
  width: 100%;
  color: #404040;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
  opacity: 0.8;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  line-clamp: 5;
  -webkit-box-orient: vertical;
`;

const Carousel = styled.div`
  display: flex;
  justify-content: center;
`;
